import { create } from 'zustand';

/**
 * Tracks in-progress manual wedding-rollup runs per agent. The Run button (in the
 * operation header) and the feed (in the body) live in separate subtrees, so they
 * coordinate through this store: the trigger marks a run pending, the feed shows a
 * "thinking" thought until it clears.
 */
interface WeddingReportRunState {
  pending: Record<string, { startedAt: number }>;
  begin: (soulId: string) => void;
  end: (soulId: string) => void;
}

export const useWeddingReportRunStore = create<WeddingReportRunState>((set) => ({
  pending: {},
  begin: (soulId) =>
    set((s) => ({
      pending: { ...s.pending, [soulId]: { startedAt: Date.now() } },
    })),
  end: (soulId) =>
    set((s) => {
      if (!s.pending[soulId]) return s;
      const next = { ...s.pending };
      delete next[soulId];
      return { pending: next };
    }),
}));
